import { useState, useEffect } from 'react';

import { Button, Card, Form, Row, Col } from 'react-bootstrap';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { checkRequired } from 'utils/validationUtils';
import TextComponent from 'components/Input/TextComponent';
import { useRestApi } from 'context/RestApiContext';
import { MessageModal } from 'components/modal/MessageModal';

import { useMaster } from 'context/MasterContext';

function ConstructionScheduleEditModal(props) {
  const restApi = useRestApi();
  // マスタ情報
  const master = useMaster();
  // 工事情報
  const [construction, setConstruction] = useState({});

  // 確認ダイアログ
  const [dialog, setDialog] = useState({});
  // エラーフィールド
  const [errorFileds, setErrorFileds] = useState([]);

  // モーダルの表示
  const [show, setShow] = useState(false);

  // モーダルパラメタの変更処理
  useEffect(() => {
    if (props?.params?.constructionData) {
      setConstruction(props.params.constructionData);
      setShow(true);
    }
  }, [props.params]);

  // 編集処理
  const handleChange = (prop) => (target) => {
    if (prop == 'GREETING_FLG' || prop == 'TAN_MEETING_FLG' || prop == 'INSPECTION_FLG') {
      setConstruction({ ...construction, [prop]: target.target.checked ? 1 : 0 });
    } else {
      setConstruction({ ...construction, [prop]: target?.value ?? target?.target.value });
    }
    // エラーのクリア
    setErrorFileds([...errorFileds].filter((x) => x != prop));
  };

  // 入力チェック
  const validate = () => {
    let errors = [];

    if (construction.INSPECTION_FLG === 1) {
      checkRequired(construction.HIKI_DATE, '引渡日', 'HIKI_DATE', errors);
    }
    setErrorFileds(errors.flatMap((x) => x.fields));

    return errors.map((x) => x.msg);
  };

  // 確定ボタン
  const handleFix = () => {
    var error = validate();
    if (error.length > 0) {
      setDialog({
        type: 'error',
        message: error,
      });
      return;
    }
    restApi.post(
      '/api/constructionScheduleList/upd',
      construction,
      (_) => {
        if (!props.params.call_list) {
          props.callbak();
        } else {
          const updatedData = {
            ...construction,
            TAN_MEETING_FLG_DISP: construction.TAN_MEETING_FLG == 1 ? '〇' : '',
            GREETING_FLG_DISP: construction.GREETING_FLG == 1 ? '〇' : '',
            INSPECTION_FLG_DISP: construction.INSPECTION_FLG == 1 ? '〇' : '',
          };
          props.params.callback(updatedData);
        }
        setShow(false);
      },
      true
    );
  };

  // 閉じるボタン処理
  const handleClose = () => {
    setShow(false);
  };

  return (
    <>
      <Dialog
        sx={{
          '& .MuiDialog-container': {
            '& .MuiPaper-root': {
              width: '100%',
              maxWidth: '780px',
            },
          },
        }}
        open={show}
        disableEnforceFocus={true}
      >
        <DialogTitle className="p-3">工事工程編集</DialogTitle>
        <DialogContent className="px-0 py-0 pr-0 pl-0">
          <Card className="m-0">
            <Card.Body>
              <Row className="pl-2 pt-2">
                <Col md="5">
                  <label>人工</label>
                </Col>
                <Col md="5">
                  <label>旧担当</label>
                </Col>
              </Row>
              <Row className="pt-1">
                <Col md="5">
                  <TextComponent
                    type="text"
                    value={construction?.JINKOU}
                    onChange={handleChange('JINKOU')}
                  ></TextComponent>
                </Col>
                <Col md="5">
                  <Form.Select
                    className="form-control"
                    value={construction?.OLD_TAN_CD}
                    onChange={handleChange('OLD_TAN_CD')}
                  >
                    <option value={'0'}>　</option>
                    {master.genbaStaff.map((x, i) => (
                      <option key={i} value={x['id']}>
                        {x['name']}
                      </option>
                    ))}
                  </Form.Select>
                </Col>
              </Row>
              <Row className="pl-1 pt-4">
                <Col md="5">
                  <label style={{ fontSize: '14pt', color: 'black' }}>
                    <input
                      className="mr-2"
                      style={{ transform: 'scale(1.5)' }}
                      type="checkbox"
                      checked={construction.TAN_MEETING_FLG == 1}
                      onChange={handleChange('TAN_MEETING_FLG')}
                    ></input>
                    担当打合
                  </label>
                </Col>
                <Col md="5">
                  <label style={{ fontSize: '14pt', color: 'black' }}>
                    <input
                      className="mr-2"
                      style={{ transform: 'scale(1.5)' }}
                      type="checkbox"
                      checked={construction.GREETING_FLG == 1}
                      onChange={handleChange('GREETING_FLG')}
                    ></input>
                    挨拶連絡
                  </label>
                </Col>
              </Row>
              <Row className="pl-2 pt-2">
                <Col md="5">
                  <label>着工(作業)予定日</label>
                </Col>
                <Col md="5">
                  <label>完成予定日</label>
                </Col>
              </Row>
              <Row className="pt-1">
                <Col md="5">
                  <TextComponent
                    value={construction.KOUKI_ST}
                    onChange={handleChange('KOUKI_ST')}
                    type="date"
                  />
                </Col>
                <Col md="5">
                  <TextComponent
                    value={construction.KOUKI_ED}
                    onChange={handleChange('KOUKI_ED')}
                    type="date"
                  />
                </Col>
              </Row>
              <Row className="pl-2 pt-2">
                <Col md="5">
                  <label>作業日連絡</label>
                </Col>
                <Col md="5">
                  <label>引渡日</label>
                </Col>
              </Row>
              <Row className="pt-1">
                <Col md="5">
                  <TextComponent
                    value={construction.WORK_SCHEDULED_DATE}
                    onChange={handleChange('WORK_SCHEDULED_DATE')}
                    type="date"
                  />
                </Col>
                <Col md="5">
                  <TextComponent
                    value={construction.HIKI_DATE}
                    onChange={handleChange('HIKI_DATE')}
                    error={errorFileds.some((x) => x == 'HIKI_DATE')}
                    type="date"
                  />
                </Col>
              </Row>
              <Row className="pl-1 pt-4">
                <Col md="5">
                  <label style={{ fontSize: '14pt', color: 'black' }}>
                    <input
                      className="mr-2"
                      style={{ transform: 'scale(1.5)' }}
                      type="checkbox"
                      checked={construction.INSPECTION_FLG == 1}
                      onChange={handleChange('INSPECTION_FLG')}
                    ></input>
                    アフターパトロールの実施
                  </label>
                </Col>
              </Row>
              <Row className="pl-2 pt-2">
                <Col md="10">
                  <label>備考</label>
                </Col>
              </Row>
              <Row className="pt-1">
                <Col md="10">
                  <TextComponent
                    type="text"
                    value={construction?.CONSTRUCTION_SCHEDULE_BIKO}
                    onChange={handleChange('CONSTRUCTION_SCHEDULE_BIKO')}
                  ></TextComponent>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </DialogContent>
        <DialogActions className="p-3" style={{ justifyContent: 'space-between' }}>
          <Button variant="secondary" className="footer-button" onClick={handleClose}>
            閉じる
          </Button>
          <Button variant="primary btn-fill" className="footer-button" onClick={handleFix}>
            更新
          </Button>
        </DialogActions>
      </Dialog>
      <MessageModal dialog={dialog}></MessageModal>
    </>
  );
}

export default ConstructionScheduleEditModal;
